import _without from 'lodash/without';

/**
 * defines the existing field types
 */

const FIELD_TYPES = {
  //STANDARD FORM FIELDS
  TEXT:            'text',
  PARAGRAPH:       'paragraph',
  NUMBER:          'number',
  CHECKBOX:        'checkbox',
  RADIO:           'radio', //radio buttons
  RATING:          'rating',
  SELECT:          'select', //dropdown
  HIDDEN:          'hidden', //while this is not a field any more, we keep it, as we do some checks on variable name being allowd as hidden field name
  BREAK:           'break',
  POLL:            'poll',
  MX_POLL:         'realtimePoll',
  MX_POLL_ANSWERS: 'realtimePollAnswers',
  //SEMANTIC FORM FIELDS
  NAME:            'name',
  ADDRESS:         'address',
  EMAIL:           'email',
  DATE:            'date',
  MX_DATE:         'mxDate',
  DATE_OF_BIRTH:   'date_of_birth',
  TIME:            'time',
  PHONE:           'phone',
  WEBSITE:         'website',
  MARKETING:       'marketing',
  MULTI_OPTIN:     'multioptin',
  COUNTRY:         'country',
  FILTER:          'filter',
  INFO:            'info',

  TERMS:              'terms_and_conditions',
  CHALLENGE_QUESTION: 'challengequestion', //quiz with radio buttons

  //USER FIELDS
  UPLOAD:              'upload',
  USER_PROFILE_UPLOAD: 'userprofileupload',
  USER_COMMENT:        'ngxfeaturedcomment',

  //QUIZ FIELDS
  GROUP:                'group',
  QUIZ_SINGLE_ANSWER:   'quizsingleanswer', //quiz with radio buttons
  QUIZ_IMAGE_ANSWER:    'quizimageanswer', //quiz with images
  QUIZ_MULTIPLE_ANSWER: 'quizmultipleanswer', //quiz with check boxes
  QUIZ_TEXT:            'quiztext', //quiz with check boxes
  QUIZ_CATEGORY:        'quizcategory', //quiz with check boxes

  MX_QUIZ_CATEGORY_SINGLE:   'quizcategorysingle', //quiz with radio boxes - can select ONLY one
  MX_QUIZ_CATEGORY_MULTIPLE: 'quizcategorymultiple', //quiz with check boxes - can select more than one

  QUIZ_SWIPE_SINGLE: 'quizswipesingle',

  //GAME FIELDS
  SPIN_THE_WHEEL_GAME: 'spinTheWheelGame',

  POLICY: 'policy',
  SUBMIT: 'submit',
};
const FIELD_TYPES_ALL = _.values(FIELD_TYPES);

const MULTI_CHOICE_FIELD_TYPES_LIST = [
  FIELD_TYPES.CHECKBOX,
  FIELD_TYPES.RADIO,
  FIELD_TYPES.RATING,
  FIELD_TYPES.SELECT,
  FIELD_TYPES.POLL,
  FIELD_TYPES.FILTER,
  FIELD_TYPES.MULTI_OPTIN,
  FIELD_TYPES.CHALLENGE_QUESTION,

  FIELD_TYPES.QUIZ_SINGLE_ANSWER,
  FIELD_TYPES.QUIZ_MULTIPLE_ANSWER,

  FIELD_TYPES.QUIZ_CATEGORY,
  FIELD_TYPES.MX_QUIZ_CATEGORY_SINGLE,
  FIELD_TYPES.MX_QUIZ_CATEGORY_MULTIPLE,

  FIELD_TYPES.MX_POLL,
  FIELD_TYPES.QUIZ_SWIPE_SINGLE,
];

const QUIZ_FIELD_TYPES_LIST = [
  FIELD_TYPES.QUIZ_SINGLE_ANSWER,
  FIELD_TYPES.QUIZ_IMAGE_ANSWER,
  FIELD_TYPES.QUIZ_MULTIPLE_ANSWER,
  FIELD_TYPES.QUIZ_TEXT,
  FIELD_TYPES.QUIZ_CATEGORY,

  FIELD_TYPES.MX_QUIZ_CATEGORY_SINGLE,
  FIELD_TYPES.MX_QUIZ_CATEGORY_MULTIPLE,

  FIELD_TYPES.QUIZ_SWIPE_SINGLE,
];

//QUIZ FIELDS
//These fields are the ones for  the `dragTypes.GROUP_FIELD` in the drop target files.
const GROUP_FIELD_TYPES_LIST = [
  FIELD_TYPES.QUIZ_SINGLE_ANSWER,
  FIELD_TYPES.QUIZ_IMAGE_ANSWER,
  FIELD_TYPES.QUIZ_MULTIPLE_ANSWER,
  FIELD_TYPES.QUIZ_TEXT,
  FIELD_TYPES.QUIZ_CATEGORY,

  FIELD_TYPES.MX_QUIZ_CATEGORY_SINGLE,
  FIELD_TYPES.MX_QUIZ_CATEGORY_MULTIPLE,
];

// we need a list of logic compatible fields in order to show the logic panel at the right time
const LOGIC_SOURCE_FIELD_TYPES_LIST = [
  FIELD_TYPES.RADIO,
  FIELD_TYPES.RATING,
  FIELD_TYPES.SELECT,
  FIELD_TYPES.CHECKBOX,
  FIELD_TYPES.MULTI_OPTIN,

  FIELD_TYPES.QUIZ_SINGLE_ANSWER,
  FIELD_TYPES.QUIZ_MULTIPLE_ANSWER,
  FIELD_TYPES.MX_QUIZ_CATEGORY_SINGLE,
  FIELD_TYPES.MX_QUIZ_CATEGORY_MULTIPLE,

  FIELD_TYPES.QUIZ_SWIPE_SINGLE,
];

//List of multi choice elements that support branching logic (NOT to be confused with MULTI_CHOICE_FIELD_TYPES_LIST)
//As some elements have a bit of a more complex value tracking because of their multi-choice, we tend to have them grouped upin here for reference for conditionals that need them
const MULTI_CHOICE_MODULES_BRANCHING_LOGIC = [
  FIELD_TYPES.CHECKBOX,
  FIELD_TYPES.MULTI_OPTIN,
  FIELD_TYPES.QUIZ_MULTIPLE_ANSWER,
  FIELD_TYPES.MX_QUIZ_CATEGORY_MULTIPLE,
];

export {
  FIELD_TYPES_ALL,
  FIELD_TYPES,
  GROUP_FIELD_TYPES_LIST,
  MULTI_CHOICE_FIELD_TYPES_LIST,
  MULTI_CHOICE_MODULES_BRANCHING_LOGIC,
  LOGIC_SOURCE_FIELD_TYPES_LIST,
  QUIZ_FIELD_TYPES_LIST,
};

export default FIELD_TYPES;
